import * as React from 'react'


export default function RadioElements({item, id, onChange, value}) {

    const handleClickElement = e => {
        onChange(e.target.defaultValue)
    }

    return <>
        <input
            type="radio"
            id={`switch-table-type-${id}`}
            name={`switch-table-type-toggle-${id}`}
            value={item.value}
            onChange={handleClickElement}
            checked={value.toString() === item.value.toString()}
        />
        <label htmlFor={`switch-table-type-${id}`} data-tour={item.dataTour || null}>{item.label}</label>
    </>
}